<template>
  <!-- Modal -->
  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="billsReportsModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" style="margin-top: 10%" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="text-join">Baixar relatório</h5>

          <button
            type="button"
            class="close"
            id="closeReportsModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style="font-size: 1.5rem">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row row-mobile">
            <div class="col-md-12">
              <br /><br />
              <h6 style="text-align: center">
                Selecione o tipo de relatório que deseja baixar
              </h6>
              <br />
              <br />
            </div>
            <div class="col-md-12 col-indent">
              <div class="row" style="justify-content: center">
                <div class="col-md-4 form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="xlsReports"
                    value="xls"
                    v-model="type"
                  />
                  <label class="form-check-label" for="exampleRadios1">
                    Gerar XLS
                  </label>
                </div>
                <div class="col-md-4 form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="pdfReports"
                    value="pdf"
                    v-model="type"
                  />
                  <label class="form-check-label" for="exampleRadios1">
                    Gerar PDF
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-12 access-center">
              <button
                class="btn btn-lg access"
                type="button"
                id="downloadReports"
                @click="getReports()"
                v-bind:disabled="processing"
              >
                Baixar
              </button>
              <br /><br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import moment from "moment";

export default {
  name: "BillsReportsModal",
  data() {
    return {
      textFilters: {},
      type: "xls",
      processing: false,
    };
  },

  props: ["selected", "filters"],

  mounted() {
    Object.keys(this.filters).map((key) => {
      if (this.filters[key].length) {
        if (key.indexOf("vencimento") >= 0) {
          this.textFilters[key] = moment(
            this.filters[key],
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          return;
        }

        if (key === "documento") {
          this.textFilters["numero_documento"] = this.filters[key];
          return;
        }

        this.textFilters[key] = this.filters[key];
      }
    });
  },

  methods: {
    getReports: function () {
      let params = {
        type: this.type,
        generation_type: this.selected.length ? "selecionados" : "total",
      };

      let queryStringFilters = Object.keys(this.textFilters)
        .map((key) => "filters[" + key + "]=" + this.textFilters[key])
        .join("&");

      if (this.selected.length) {
        params.boleto_id = this.selected;
      }

      Vue.$toast.success("Aguarde! Estamos preparando seu relatório.", {
        position: "top-right",
        duration: 5000,
      });

      this.processing = true;
      $("#billsReportsModal").modal('hide');

      axios
        .get(`${process.env.API_PBM}/boletos/reports?${queryStringFilters}`, {
          params,
          responseType: "blob",
        })
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));

          let fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute(
            "download",
            `relatorio_${new Date().toLocaleString()}.${this.type}`
          );
          document.body.appendChild(fileLink);
          fileLink.click();

          this.processing = false;
        })
        .catch((error) => {
          this.processing = false;
          Vue.$toast.error("Ops! Não foi possível completar a ação.", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-indent {
  justify-content: center;
  margin-left: 25px;
  margin-bottom: 30px;
}
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 35%;
}
.col-style {
  display: flex;
  justify-content: space-around;
  text-align: initial;
  font-size: 14px;
}

.modal-body {
  color: rgb(100, 95, 95);
}
.btn-style {
  border: none;
  background-color: #ffffff;
  cursor: pointer;
  color: rgb(100, 95, 95);
  font-size: 15px;
}

.icons {
  font-size: 17px;
  color: rgb(100, 95, 95);
  margin: 5px;
}

span {
  font-size: 16px;
}
.access {
  color: #fff;
  margin-top: 60px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  width: 25%;
}
.access-center {
  text-align: center;
  display: flex;
  justify-content: center;
}
.close {
  font-size: 1.5rem !important;
}
@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 27% !important;
  }

  .access-center {
    text-align: center;
    display: flex;
    margin-top: -60px;
    justify-content: center;
  }

  .col-md-4 {
    margin-top: 20px;
  }

  .modal-dialog {
    margin-top: 55% !important;
  }
}

@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
}
</style>



// WEBPACK FOOTER //
// src/views/components/home/bill/BillsReportsModal.vue